module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<span class="navigation__label">'+
((__t=( obj.name ))==null?'':__t)+
'</span>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/header/list/templates/navigation-item.html
// module id = 450
// module chunks = 0